import { Anchor, Breadcrumbs, Card, Grid } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';
import CompaniesForm from './CompaniesForm';

const page = `${Page['companies']}`;

const CompaniesEditPage = () => {
  const { accountId, domainId, id } = useParams();
  const [company, setCompany] = useState();
  const [error, setError] = useState();
  const fetch = useFetch();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/companies/${encodeURIComponent(id)}`)
      .then(({ company }) => {
        setCompany(company);
      })
      .catch(setError);
  }, [accountId, domainId, id, fetch]);

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  let title = `${page}`;
  if (company?.name) {
    title += ` | ${company.name}`;
  }
  title += ' | Ediit';

  return (
    <>
      <Metadata title={title} />
      <Breadcrumbs>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/companies`}>{page}</Anchor>
        {company && company.firstName && company.lastName && (
          <Anchor href={`#/accounts/${accountId}/domains/${domainId}/companies/${encodeURIComponent(id)}`}>
            {company.name}
          </Anchor>
        )}
        <Anchor>Edit</Anchor>
      </Breadcrumbs>

      <Grid>
        <Grid.Col>
          <Card withBorder>
            <Card.Section inheritPadding py="sm">
              <CompaniesForm company={company} />
            </Card.Section>
          </Card>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default CompaniesEditPage;
